/**
 * @author Ivan Torres
 */
import { __read } from "tslib";
import cx from '../classNames';
import _parseStyle from './_parseStyle';
var _css = function (utils, styletronCSS) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    // NOTE: prepend previously generated classes by styletron, this can happen
    // when re-styling a component built with `styled` or `className` added
    // on top of it:
    var _a = __read(_parseStyle(utils, {}, args), 2), styleObject = _a[0], invalidArgs = _a[1];
    return cx(invalidArgs, styletronCSS(styleObject));
};
export default _css;
